const ONE_DAY = 86400000;
const TWO_HOURS = 7200000;
const NINETY_MINUTES = 5400000;
const THIRTY_MINUTES = 1800000;
export const MOCK_LIVE_EVENT_ID = 1001;
const DEFAULT_TITLE = 'CRM Workshop 1: How to Setup and Use Your HubSpot Account';
const DEFAULT_DESCRIPTION = "Join our 30-minute live session to learn how Academy Onboarding works, explore your resources, register for bootcamps, and get your questions answered. You'll leave with a clear plan and know exactly what to do next.";
export const MOCK_INSTRUCTORS = [{
  contentId: 1,
  id: 1,
  name: 'Patrick Eng',
  jobTitle: 'Senior Inbound Professor',
  organisation: 'HubSpot',
  organisationUrl: 'https://www.hubspot.com',
  image: 'https://137828.fs1.hubspotusercontent-na1.net/hub/137828/hubfs/reduced-Thumbnail_Engaging%20Your%20Email%20Deliverability%20in%20HubSpot.jpg?width=90',
  descriptions: {
    en: 'Patrick is a Senior Inbound Professor based in Fairfax, Virginia. His journey with HubSpot began 10 years ago in college when he worked as an intern for a partner agency. After 4 years of onboarding customers to HubSpot as a partner, he made the transition to work for HubSpot and has been helping customers solve problems and learn HubSpot ever since.'
  }
}];
export const createSession = ({
  duration = TWO_HOURS,
  id,
  liveEventId = MOCK_LIVE_EVENT_ID,
  offset,
  recordingLink
}) => ({
  id,
  liveEventId,
  startTime: Date.now() + offset,
  endTime: Date.now() + offset + duration,
  platform: 'zoom',
  platformLink: `https://zoom.us/j/${id}`,
  platformId: String(id),
  recordingLink
});
export const createAssignment = ({
  attended = false,
  id,
  joinLink,
  sessionId,
  status = 'registered'
}) => ({
  id,
  userId: 1,
  sessionId,
  status,
  attended,
  joinLink: joinLink !== null && joinLink !== void 0 ? joinLink : '',
  zoomRegistrantId: `mock-registrant-${id}`
});
const upcomingSessions = [createSession({
  id: 2001,
  offset: ONE_DAY * 2
}), createSession({
  id: 2002,
  offset: ONE_DAY * 12
}), createSession({
  duration: THIRTY_MINUTES,
  id: 2003,
  offset: ONE_DAY * 22
}), createSession({
  duration: NINETY_MINUTES,
  id: 2004,
  offset: ONE_DAY * 32
})];
const liveSession = createSession({
  id: 2100,
  offset: -THIRTY_MINUTES
});
const pastSessionWithRecording = createSession({
  id: 2200,
  offset: -(ONE_DAY * 8),
  recordingLink: 'https://zoom.us/rec/past-recording'
});
const TEST_SCENARIOS = {
  liveRegistered: {
    sessions: [liveSession, ...upcomingSessions],
    assignments: [createAssignment({
      id: 3100,
      joinLink: 'https://zoom.us/w/live-join',
      sessionId: liveSession.id
    })]
  },
  liveUnregistered: {
    sessions: [liveSession, ...upcomingSessions],
    assignments: []
  },
  upcomingRegistered: {
    sessions: upcomingSessions,
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    })]
  },
  pastAttended: {
    sessions: [pastSessionWithRecording, ...upcomingSessions],
    assignments: [createAssignment({
      attended: true,
      id: 3200,
      sessionId: pastSessionWithRecording.id
    })]
  },
  pastRegistered: {
    sessions: [pastSessionWithRecording, ...upcomingSessions],
    assignments: [createAssignment({
      id: 3200,
      sessionId: pastSessionWithRecording.id
    })]
  },
  noAlert: {
    sessions: upcomingSessions,
    assignments: []
  },
  nextStepOneRegistered: {
    sessions: [createSession({
      id: 2001,
      liveEventId: 1001,
      offset: ONE_DAY * 10
    }), createSession({
      id: 2010,
      liveEventId: 1002,
      offset: ONE_DAY * 2
    }), createSession({
      id: 2011,
      liveEventId: 1003,
      offset: ONE_DAY * 15
    })],
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    })]
  },
  nextStepAllRegistered: {
    sessions: [createSession({
      id: 2001,
      liveEventId: 1001,
      offset: ONE_DAY * 2
    }), createSession({
      id: 2010,
      liveEventId: 1002,
      offset: ONE_DAY * 5
    }), createSession({
      id: 2011,
      liveEventId: 1003,
      offset: ONE_DAY * 15
    })],
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3010,
      sessionId: 2010
    }), createAssignment({
      id: 3011,
      sessionId: 2011
    })]
  },
  nextStepTwoRegistered: {
    sessions: [createSession({
      id: 2001,
      liveEventId: 1001,
      offset: ONE_DAY * 20
    }), createSession({
      id: 2010,
      liveEventId: 1002,
      offset: ONE_DAY * 15
    }), createSession({
      id: 2011,
      liveEventId: 1003,
      offset: ONE_DAY * 2
    })],
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3010,
      sessionId: 2010
    })]
  },
  nextStepCancelledAssignment: {
    sessions: [createSession({
      id: 2001,
      liveEventId: 1001,
      offset: ONE_DAY * 2
    }), createSession({
      id: 2010,
      liveEventId: 1002,
      offset: ONE_DAY * 5
    })],
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001,
      status: 'cancelled'
    })]
  },
  nextStepMultipleSessionsSameEvent: {
    sessions: [createSession({
      id: 2001,
      liveEventId: 1001,
      offset: ONE_DAY * 2
    }), createSession({
      id: 2002,
      liveEventId: 1001,
      offset: ONE_DAY * 12
    }), createSession({
      id: 2010,
      liveEventId: 1002,
      offset: ONE_DAY * 5
    })],
    assignments: [createAssignment({
      id: 3001,
      sessionId: 2001
    }), createAssignment({
      id: 3002,
      sessionId: 2002
    })]
  }
};
const DEFAULT_SCENARIO = {
  sessions: upcomingSessions,
  assignments: []
};
const getTestScenario = () => {
  const testParam = new URLSearchParams(window.location.search).get('test');
  if (testParam && testParam in TEST_SCENARIOS) {
    return TEST_SCENARIOS[testParam];
  }
  return DEFAULT_SCENARIO;
};
const MOCK_LIVE_EVENT = {
  id: MOCK_LIVE_EVENT_ID,
  title: 'CRM Workshop 2: How to Setup and Use Your HubSpot Account',
  internalName: 'crm-workshop-1002',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
};
export const MOCK_LIVE_EVENTS_LIST = [MOCK_LIVE_EVENT, {
  id: 1002,
  title: 'CRM Workshop 3: How to Setup and Use Your HubSpot Account',
  internalName: 'crm-workshop-1003',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
}, {
  id: 1003,
  title: DEFAULT_TITLE,
  internalName: 'crm-workshop-1001',
  description: DEFAULT_DESCRIPTION,
  type: 'workshop',
  instructors: ['1'],
  language: 'EN',
  previewThumbnailRectangleUrl: 'https://885765335.fs1.hubspotusercontentqa-na1.net/hubfs/885765335/rectangle-Arabian-dromedary-camel.webp'
}];
export const getMockFullLiveEvent = __liveEventId => {
  const scenario = getTestScenario();
  return {
    liveEvent: MOCK_LIVE_EVENT,
    sessions: scenario.sessions,
    assignments: scenario.assignments
  };
};